import { AppRootState } from './appStore'
import { selectIsPreviewMode } from './selectPreview'

// true when nothing the user does in a form may be persisted or uploaded:
// imports, encounter status updates, and encounter files
export const selectWritesDisabled = (state: AppRootState): boolean => {
	return state.app.isTrainingMode || selectIsPreviewMode(state)
}
